module.exports = __webpack_public_path__ + "static/Sergei-hidden-9ef4d55bcf96b9c16e697f8768bc9953.jpg";